module.exports = __webpack_public_path__ + "img/Ob.499f2b5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/Ob.jpg
// module id = vHMC
// module chunks = 1